@for (tag of tags; track $index) {
<ul>
    <mat-checkbox [(ngModel)]="tag.checked" (ngModelChange)="onCheckChanged(tag)"
        [disabled]="disabled">{{tag.value}}</mat-checkbox>
</ul>
}